import { Dialog, Box, Typography, Button, Slider } from "@mui/material";
import React, { useEffect, useState } from "react";
import ProgressBar from "./ProgressBar";
import Icon from "../../../components/Icon";

const mainButtonStyle = {
  width: "200px",
  height: "150px",
  borderRadius: "20px",
  margin: 2,
};

export default function UserInfoModal({ setOpen }) {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const listen = () => setWidth(window.innerWidth);

    window.addEventListener("resize", listen);
    listen();

    return () => window.removeEventListener("resize", listen);
  }, []);

  const [form, setForm] = useState({
    gender: null,
    age: 30,
  });
  const [ageComplete, setAgeComplete] = useState(false);

  useEffect(() => {
    if (!!form.location) {
      localStorage.setItem("userInfo", JSON.stringify(form));
      setOpen(false);
    }
  }, [form.location]);

  const status = !form.gender ? 0 : !ageComplete ? 1 : !form.location ? 2 : 3;

  return (
    <Box
      sx={{
        p: 2,
        width: "100vw",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        mx: "auto",
        mt: width > 900 ? 5 : 0,
      }}
    >
      <Box sx={{ mx: "auto", p: 2 }}>
        <Icon section="info" />
        {/* <ProgressBar
          sections={{
            userInfo: {
              questions: {
                length: 3,
              },
            },
          }}
          position={["userInfo", status]}
        /> */}
      </Box>
      {!form.gender && (
        <>
          <Typography variant="h5" fontWeight="bold">
            What is your gender?
          </Typography>
          <Box p={2} textAlign={"center"}>
            {["Man", "Woman", "Other"].map((g) => {
              return (
                <Button
                  onClick={() => setForm({ ...form, gender: g })}
                  variant="contained"
                  sx={{
                    ...mainButtonStyle,
                    ...(g === form.gender && { background: "#0a5e43" }),
                  }}
                >
                  {g}
                </Button>
              );
            })}
          </Box>
        </>
      )}
      {!!form.gender && !ageComplete && (
        <>
          <Typography variant="h5" fontWeight="bold">
            What is your age?
          </Typography>
          <Box p={2}>
            <Typography width="100%" textAlign={"center"}>
              {form.age}
            </Typography>
            <Slider
              sx={{ maxWidth: "500px" }}
              min={18}
              max={100}
              step={1}
              value={form.age}
              onChange={(e) => setForm({ ...form, age: e.target.value })}
            />
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Button variant="contained" onClick={() => setAgeComplete(true)}>
              Next
            </Button>
          </Box>
        </>
      )}
      {ageComplete && !form.location && (
        <>
          <Typography variant="h5" fontWeight="bold">
            What is your location?
          </Typography>
          <Box p={2}>
            {["England", "Scotland", "Wales", "Northern Ireland", "Other"].map(
              (l) => {
                return (
                  <Button
                    variant="contained"
                    onClick={() => setForm({ ...form, location: l })}
                    sx={{
                      ...mainButtonStyle,
                      ...(l === form.location && {
                        background: "#0a5e43",
                      }),
                    }}
                  >
                    {l}
                  </Button>
                );
              }
            )}
          </Box>
        </>
      )}
    </Box>
  );
}
